import PropTypes from 'prop-types';

var offsetValueKeys = [2, 4, 6, 8, 10, 12, 14, 16, 20, 24];
var globalPropTypes = {
  paddingTop: PropTypes.oneOf(offsetValueKeys),
  paddingLeft: PropTypes.oneOf(offsetValueKeys),
  paddingRight: PropTypes.oneOf(offsetValueKeys),
  paddingBottom: PropTypes.oneOf(offsetValueKeys),
  padding: PropTypes.oneOf(offsetValueKeys),
  marginTop: PropTypes.oneOf(offsetValueKeys),
  marginLeft: PropTypes.oneOf(offsetValueKeys),
  marginRight: PropTypes.oneOf(offsetValueKeys),
  marginBottom: PropTypes.oneOf(offsetValueKeys),
  margin: PropTypes.oneOf(offsetValueKeys),
  inheritBorderRadius: PropTypes.bool,
  rounded: PropTypes.bool,
  circled: PropTypes.bool,
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  alignSelf: PropTypes.oneOf(['center', 'flex-end', 'flex-start', 'stretch']),
  justifyContent: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between']),
  flexBasis: PropTypes.oneOf(['50pct']),
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  flexGrow: PropTypes.oneOf([0, 1, 9999999999]),
  flexShrink: PropTypes.oneOf([0, 1]),
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  preventUserSelect: PropTypes.bool,
  fontFamily: PropTypes.oneOf(['arial', 'open-sans'])
};
var globalPropTypes$1 = (function (prop) {
  return globalPropTypes[prop];
});

export { globalPropTypes$1 as g };
//# sourceMappingURL=globalPropTypes-bb98efc9.js.map
